export default __webpack_public_path__ + "static/media/miniclose.f06cc4bb.svg";